import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { ToastContainer, ToastButton, ToastContent, ToastMessage, ToastTitle } from './styles'

// todo: ELM-2139 -- move this into a context provider that is shared at the app level (see source/app/components/app.jsx)
const Toast = ({ toastList, dismissTime = 3000 }) => {
  const [displayList, setDisplayList] = useState(toastList)

  // todo: take in successMessages and errorMessages, map them to toasts so that the consumer doesn't have to know anything except "display this string"
  useEffect(() => {
    setDisplayList([...toastList])
  }, [toastList])

  useEffect(() => {
    const interval = setInterval(() => {
      if (toastList.length && displayList.length) {
        deleteToast(toastList[0].id)
      }
    }, dismissTime)

    return () => {
      clearInterval(interval)
    }
  }, [toastList, dismissTime, displayList])

  const deleteToast = (id) => {
    const listItemIndex = displayList.findIndex((e) => e.id === id)
    const toastListItem = toastList.findIndex((e) => e.id === id)
    displayList.splice(listItemIndex, 1)
    toastList.splice(toastListItem, 1)
    setDisplayList([...displayList])
  }

  return (
    <ToastContainer>
      {
        displayList.map((toast, i) => (
          <ToastContent
            key={i}
            style={{ borderLeft: `6px solid ${toast.borderColor}` }}
          >
            <ToastButton onClick={() => deleteToast(toast.id)}>
              X
            </ToastButton>
            <div>
              <ToastTitle>{toast.title}</ToastTitle>
              <ToastMessage>
                {toast.description}
              </ToastMessage>
            </div>
          </ToastContent>
        ))
        }
    </ToastContainer>
  )
}

Toast.propTypes = { toastList: PropTypes.array.isRequired }

export default Toast
